import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Presentation, Heart, Brain, Users, Target, BookOpen, Download, CheckCircle, Star, Sparkles, MessageCircle, Lightbulb, Zap, FileText, Video, ShoppingBag, Plus, Check } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { toast } from 'sonner';

const HomePage = () => {
  const [email, setEmail] = useState('');
  const { addItem, items } = useCart();

  // Featured products for homepage
  const featuredProducts = [
    {
      id: 'prod-1',
      title: 'Emocijų dienoraštis',
      description: 'PDF darbo knyga su pratimais emocijų atpažinimui ir valdymui. 30 dienų programa.',
      price: 9.99,
      file_type: 'PDF',
      color: 'bg-[#4CAF50]',
      lightColor: 'bg-[#E8F5E9]',
      features: ['30 dienų programa', '50+ pratimų']
    },
    {
      id: 'prod-2',
      title: 'Streso valdymo gidas',
      description: 'Išsamus vadovas su praktinėmis technikomis kasdieniam streso valdymui.',
      price: 14.99,
      file_type: 'PDF',
      color: 'bg-[#FF9F43]',
      lightColor: 'bg-[#FFF3E0]',
      features: ['80 puslapių', 'Audio meditacijos']
    },
    {
      id: 'prod-3',
      title: 'Emocinio intelekto pagrindai',
      description: 'Video kursas apie emocinio intelekto ugdymą. 5 valandos turinio.',
      price: 49.99,
      file_type: 'Video kursas',
      color: 'bg-[#5B9BD5]',
      lightColor: 'bg-[#E3F2FD]',
      features: ['5 val. video', '10 modulių']
    },
    {
      id: 'prod-5',
      title: 'Sąmoningumo praktika',
      description: 'Audio meditacijų rinkinys kasdienei sąmoningumo praktikai.',
      price: 19.99,
      file_type: 'Audio',
      color: 'bg-[#9B59B6]',
      lightColor: 'bg-[#F3E5F5]',
      features: ['20 meditacijų', '3+ valandos']
    }
  ];

  const handleAddToCart = (product) => {
    addItem({
      id: product.id,
      title: product.title,
      price: product.price,
      quantity: 1
    });
    toast.success(`"${product.title}" pridėta į krepšelį`);
  };

  const isInCart = (productId) => {
    return items.some(item => item.id === productId);
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    alert('Ačiū! Jūs sėkmingai užsiprenumeravote naujienlaišką.');
    setEmail('');
  };

  const services = [
    { 
      icon: Presentation, 
      title: 'Mokymai įmonėms', 
      description: 'Profesionalūs, praktiniai mokymai jūsų komandai',
      color: 'bg-[#4CAF50]',
      lightColor: 'bg-[#E8F5E9]',
      iconColor: 'text-[#4CAF50]',
      link: '/mokymai'
    },
    { 
      icon: Heart, 
      title: 'Koučingo sesijos', 
      description: 'Individualios sesijos asmeniniam augimui',
      color: 'bg-[#FF9F43]',
      lightColor: 'bg-[#FFF3E0]',
      iconColor: 'text-[#FF9F43]',
      link: '/sesijos'
    },
    { 
      icon: Download, 
      title: 'Skaitmeniniai produktai', 
      description: 'PDF, darbo knygos ir video mokymai',
      color: 'bg-[#5B9BD5]',
      lightColor: 'bg-[#E3F2FD]',
      iconColor: 'text-[#5B9BD5]',
      link: '/parduotuve'
    }
  ];

  const trainingTopics = [
    { icon: Brain, title: 'Emocinis intelektas', color: 'bg-[#4CAF50]', lightColor: 'bg-[#E8F5E9]' },
    { icon: Heart, title: 'Emocinė sveikata', color: 'bg-[#FF6B6B]', lightColor: 'bg-[#FFEBEE]' },
    { icon: Zap, title: 'Streso valdymas', color: 'bg-[#FF9F43]', lightColor: 'bg-[#FFF3E0]' },
    { icon: Users, title: 'Sudėtingos asmenybės', color: 'bg-[#9B59B6]', lightColor: 'bg-[#F3E5F5]' },
    { icon: Target, title: 'Perdegimo prevencija', color: 'bg-[#5B9BD5]', lightColor: 'bg-[#E3F2FD]' },
    { icon: MessageCircle, title: 'Konfliktų valdymas', color: 'bg-[#FF6B6B]', lightColor: 'bg-[#FFEBEE]' },
    { icon: Sparkles, title: 'Viešasis kalbėjimas', color: 'bg-[#FFD93D]', lightColor: 'bg-[#FFFDE7]' },
    { icon: Lightbulb, title: 'Psichologinis saugumas', color: 'bg-[#4CAF50]', lightColor: 'bg-[#E8F5E9]' }
  ];

  const testimonials = [
    {
      name: 'Indrė S.',
      company: 'Konfliktų valdymo mokymai',
      text: 'Labai patiko kad turėjom pavyzdžių ir praktikos. Labai patiko tai, kad nebuvo tik teorija iš vadovėlio, bet ir pasipraktikavom, turėjom atviros diskusijos. Tikrai buvo įdomu klausyti.',
      rating: 5,
      color: 'bg-[#FFEBEE]'
    },
    {
      name: 'Justina R.',
      company: 'Emocinio intelekto mokymai',
      text: 'Labai įdomūs ir naudingi mokymai. Man jie sakyčiau buvo kaip terapija, stabtelėjimas ir pabūvimas su savo mintimis, paanalizavimas savo būsenos, jausmų, emocijų. Šiame lekiančiame pasaulyje labai trūksta tokio laiko sau.',
      rating: 5,
      color: 'bg-[#E8F5E9]'
    },
    {
      name: 'Tomas K.',
      company: 'Emocinio intelekto, Konfliktų ir Streso valdymo mokymai',
      text: 'Rasa yra vienas šilčiausių ir labiausiai įkvepiančių kada nors sutiktų trenerių. Dalyvavau keliuose jos mokymuose, visi patiko, bet labiausiai sužavėjo jos sugebėjimas sukurti gerą atmosferą.',
      rating: 5,
      color: 'bg-[#FFF3E0]'
    },
    {
      name: 'Monika V.',
      company: 'Bendravimo su sudėtingomis asmenybėmis mokymai',
      text: 'Mokymai man pasirodė vieni naudingiausių, kuriuose esu dalyvavusi. Lektorė informaciją pateikė labai aiškiai ir įdomiai. Ypač patiko konkrečios technikos pokalbiams ir praktinė dalis.',
      rating: 5,
      color: 'bg-[#F3E5F5]'
    },
    {
      name: 'Darius P.',
      company: 'Bendravimo su sudėtingomis asmenybėmis mokymai',
      text: 'Įdomi ir naudinga teorijos dalis su užduotimis. Didžiausia nauda visiems manau praktika, video situacijų nagrinėjimas, tikrai prideda naudingos vertės.',
      rating: 5,
      color: 'bg-[#E3F2FD]'
    },
    {
      name: 'Eglė M.',
      company: 'Bendravimo su sudėtingomis asmenybėmis mokymai',
      text: 'Likau nustebinta, kaip galima giliai įvertinti situaciją ir žmonių būseną. Labai lengvai ir aiškiai buvo išklausyti šie mokymai. Ačiū jums labai.',
      rating: 5,
      color: 'bg-[#FFFDE7]'
    },
    {
      name: 'Andrius J.',
      company: 'Bendravimo su sudėtingomis asmenybėmis mokymai',
      text: 'Labai imponavo, kad mokymai pritaikyti konkrečiam mūsų darbui, situacijų parinkimai, pavyzdžiai. Mokymai personalizuoti, o ne abstraktūs.',
      rating: 5,
      color: 'bg-[#E8F5E9]'
    }
  ];

  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section className="bg-[#FAFAF8] py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div data-testid="hero-content">
              <div className="inline-flex items-center space-x-2 bg-[#E8F5E9] text-[#4CAF50] px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Sparkles className="w-4 h-4" />
                <span>Mokymų trenerė, ugdomojo konsultavimo specialistė</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-['Poppins'] font-bold leading-tight text-[#2D3748] mb-6">
                Stiprinkite <span className="text-[#4CAF50]">emocinius įgūdžius</span> su manimi
              </h1>
              
              <p className="text-lg text-[#718096] leading-relaxed mb-8">
                > 10 metų vedu mokymus organizacijoms ir asmenims, padėdama jiems stiprinti emocinę sveikatą, gerinti bendravimo ir konfliktų sprendimo įgūdžius.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/sesijos"
                  data-testid="cta-consultation-button"
                  className="inline-flex items-center justify-center bg-[#4CAF50] text-white hover:bg-[#43A047] rounded-full px-8 py-4 font-semibold transition-all hover:-translate-y-1 shadow-lg shadow-green-200"
                >
                  Konsultacijos
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
                <Link
                  to="/mokymai"
                  data-testid="cta-training-button"
                  className="inline-flex items-center justify-center bg-[#FF9F43] text-white hover:bg-[#E08A3A] rounded-full px-8 py-4 font-semibold transition-all hover:-translate-y-1 shadow-lg shadow-orange-200"
                >
                  Mokymų temos
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
              </div>
            </div>

            {/* Hero image */}
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src={`${process.env.REACT_APP_BACKEND_URL}/api/files/home/rasa-hero.jpg`}
                  alt="TavoEmocijos - Mokymų trenerė ir koučerė"
                  className="w-full h-auto object-cover"
                />
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-[#FFD93D] rounded-full opacity-60 -z-10"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-[#5B9BD5] rounded-full opacity-60 -z-10"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Digital Products Section - MOVED UP */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-2 bg-[#E3F2FD] text-[#5B9BD5] px-4 py-2 rounded-full text-sm font-medium mb-4">
              <ShoppingBag className="w-4 h-4" />
              <span>Skaitmeninė parduotuvė</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748] mb-4">
              Skaitmeniniai produktai
            </h2>
            <p className="text-lg text-[#718096] max-w-2xl mx-auto">
              PDF vadovai, video kursai ir audio meditacijos savarankiškam mokymuisi
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {featuredProducts.map((product) => {
              const inCart = isInCart(product.id);
              return (
                <div 
                  key={product.id}
                  data-testid={`featured-product-${product.id}`}
                  className="bg-white rounded-2xl border border-slate-100 overflow-hidden hover:shadow-xl transition-all hover:-translate-y-1"
                >
                  {/* Product Header */}
                  <div className={`${product.lightColor} p-6`}>
                    <div className={`w-12 h-12 ${product.color} rounded-xl flex items-center justify-center mb-4`}>
                      {product.file_type === 'PDF' && <FileText className="w-6 h-6 text-white" />}
                      {product.file_type === 'Video kursas' && <Video className="w-6 h-6 text-white" />}
                      {product.file_type === 'Audio' && <Download className="w-6 h-6 text-white" />}
                    </div>
                    <span className="text-xs font-medium text-[#718096] bg-white/80 px-2 py-1 rounded-full">
                      {product.file_type}
                    </span>
                  </div>

                  {/* Product Content */}
                  <div className="p-5">
                    <h3 className="font-['Poppins'] font-semibold text-[#2D3748] mb-2">
                      {product.title}
                    </h3>
                    <p className="text-sm text-[#718096] mb-4 line-clamp-2">
                      {product.description}
                    </p>

                    {/* Features */}
                    <div className="flex flex-wrap gap-2 mb-4">
                      {product.features.map((feature, idx) => (
                        <span 
                          key={idx}
                          className="text-xs bg-slate-100 text-[#718096] px-2 py-1 rounded-full"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>

                    {/* Price and Button */}
                    <div className="flex items-center justify-between">
                      <span className="text-xl font-bold text-[#2D3748]">
                        €{product.price.toFixed(2)}
                      </span>
                      <button
                        onClick={() => handleAddToCart(product)}
                        disabled={inCart}
                        data-testid={`add-to-cart-${product.id}`}
                        className={`flex items-center space-x-1 px-4 py-2 rounded-full text-sm font-medium transition-all ${
                          inCart
                            ? 'bg-[#E8F5E9] text-[#4CAF50]'
                            : 'bg-[#4CAF50] text-white hover:bg-[#43A047]'
                        }`}
                      >
                        {inCart ? (
                          <>
                            <Check className="w-4 h-4" />
                            <span>Krepšelyje</span>
                          </>
                        ) : (
                          <>
                            <Plus className="w-4 h-4" />
                            <span>Į krepšelį</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/parduotuve"
              data-testid="view-all-products-button"
              className="inline-flex items-center bg-[#5B9BD5] text-white hover:bg-[#4A8BC4] rounded-full px-8 py-4 font-semibold transition-all hover:-translate-y-1 shadow-lg shadow-blue-200"
            >
              <ShoppingBag className="w-5 h-5 mr-2" />
              Visi produktai
              <ArrowRight className="w-5 h-5 ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748] mb-4">
              Kaip galiu padėti?
            </h2>
            <p className="text-lg text-[#718096] max-w-2xl mx-auto">
              Pasirinkite paslaugą, kuri geriausiai atitinka jūsų poreikius
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <Link 
                  to={service.link}
                  key={index} 
                  data-testid={`service-card-${index}`} 
                  className="bg-white p-8 rounded-3xl border-2 border-slate-100 hover:border-transparent hover:shadow-xl transition-all group"
                >
                  <div className={`w-16 h-16 ${service.lightColor} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                    <Icon className={`w-8 h-8 ${service.iconColor}`} />
                  </div>
                  <h3 className="text-xl font-['Poppins'] font-semibold mb-3 text-[#2D3748]">
                    {service.title}
                  </h3>
                  <p className="text-[#718096] leading-relaxed mb-4">
                    {service.description}
                  </p>
                  <div className={`flex items-center ${service.iconColor} font-medium`}>
                    Sužinoti daugiau 
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Training Topics */}
      <section className="py-16 md:py-24 bg-[#FAFAF8]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748] mb-4">
              Mokymų temos
            </h2>
            <p className="text-lg text-[#718096] max-w-2xl mx-auto">
              Plataus spektro mokymai, pritaikyti jūsų organizacijos poreikiams
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {trainingTopics.map((topic, index) => {
              const Icon = topic.icon;
              return (
                <div 
                  key={index} 
                  data-testid={`training-topic-${index}`} 
                  className={`${topic.lightColor} p-6 rounded-2xl text-center hover:scale-105 transition-transform cursor-pointer`}
                >
                  <div className={`w-12 h-12 ${topic.color} rounded-xl flex items-center justify-center mx-auto mb-3`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="font-semibold text-[#2D3748] text-sm">
                    {topic.title}
                  </h3>
                </div>
              );
            })}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/mokymai"
              data-testid="view-all-trainings-button"
              className="inline-flex items-center bg-[#4CAF50] text-white hover:bg-[#43A047] rounded-full px-8 py-4 font-semibold transition-all hover:-translate-y-1 shadow-lg shadow-green-200"
            >
              Peržiūrėti visas programas
              <ArrowRight className="w-5 h-5 ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* Photo Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748] mb-4">
              Mokymų akimirkos
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="rounded-2xl overflow-hidden">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/about/training-1.jpg`}
                alt="Mokymai"
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/about/training-2.jpg`}
                alt="Mokymai"
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/about/training-3.jpg`}
                alt="Mokymai"
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/about/training-4.jpg`}
                alt="Mokymai"
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/home/training-1.jpg`}
                alt="Mokymai"
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/home/training-2.jpg`}
                alt="Mokymai"
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/home/training-3.jpg`}
                alt="Mokymai"
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}/api/files/home/training-4.jpg`}
                alt="Mokymai"
                className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 md:py-24 bg-[#FAFAF8]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748] mb-4">
              Klientų atsiliepimai
            </h2>
            <p className="text-lg text-[#718096] max-w-2xl mx-auto">
              Ką sako žmonės apie mūsų bendradarbiavimą
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.slice(0, 6).map((testimonial, index) => (
              <div 
                key={index} 
                data-testid={`testimonial-${index}`} 
                className={`${testimonial.color} p-6 rounded-3xl`}
              >
                <div className="flex items-center mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-[#FFD93D] fill-current" />
                  ))}
                </div>
                <p className="text-[#2D3748] leading-relaxed mb-4 text-sm">"{testimonial.text}"</p>
                <div>
                  <p className="font-semibold text-[#2D3748]">{testimonial.name}</p>
                  <p className="text-xs text-[#718096]">{testimonial.company}</p>
                </div>
              </div>
            ))}
          </div>
          
          {/* Last testimonial - full width */}
          <div className="mt-6">
            <div className={`${testimonials[6].color} p-8 rounded-3xl max-w-2xl mx-auto`}>
              <div className="flex items-center mb-4 justify-center">
                {[...Array(testimonials[6].rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-[#FFD93D] fill-current" />
                ))}
              </div>
              <p className="text-[#2D3748] leading-relaxed mb-4 text-center">"{testimonials[6].text}"</p>
              <div className="text-center">
                <p className="font-semibold text-[#2D3748]">{testimonials[6].name}</p>
                <p className="text-sm text-[#718096]">{testimonials[6].company}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lead Magnet */}
      <section className="py-16 md:py-24 bg-[#4CAF50]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl text-center">
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Download className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-white mb-4">
            Nemokamas PDF gidas
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Atsisiųskite "Emocinės Savistabos Gidas" ir pradėkite savo kelionę į geresnę emocinę sveikatą
          </p>
          <form onSubmit={handleNewsletterSubmit} data-testid="newsletter-form" className="max-w-md mx-auto flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Jūsų el. paštas"
              required
              data-testid="newsletter-email-input"
              className="flex-1 h-14 rounded-full px-6 focus:outline-none focus:ring-2 focus:ring-white/50"
            />
            <button
              type="submit"
              data-testid="newsletter-submit-button"
              className="bg-white text-[#4CAF50] hover:bg-slate-100 rounded-full px-8 py-4 font-semibold transition-colors whitespace-nowrap"
            >
              Gauti gidą
            </button>
          </form>
        </div>
      </section>

      {/* Legal Information Section */}
      <section className="bg-white py-16 border-t border-slate-200">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-6xl">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-['Poppins'] font-bold text-[#2D3748] mb-3">
              Svarbi informacija
            </h2>
            <p className="text-[#718096]">
              Susipažinkite su mūsų taisyklėmis ir sąlygomis
            </p>
          </div>
          
          {/* Legal Links */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
            <Link to="/salygos" className="bg-[#E8F5E9] hover:bg-[#C8E6C9] rounded-2xl p-6 text-center transition-colors">
              <BookOpen className="w-8 h-8 text-[#4CAF50] mx-auto mb-3" />
              <h3 className="font-semibold text-[#2D3748]">Pirkimo taisyklės</h3>
              <p className="text-sm text-[#718096] mt-1">Pirkimo ir pardavimo sąlygos</p>
            </Link>
            <Link to="/privatumas" className="bg-[#E3F2FD] hover:bg-[#BBDEFB] rounded-2xl p-6 text-center transition-colors">
              <CheckCircle className="w-8 h-8 text-[#5B9BD5] mx-auto mb-3" />
              <h3 className="font-semibold text-[#2D3748]">Privatumo politika</h3>
              <p className="text-sm text-[#718096] mt-1">Duomenų apsauga</p>
            </Link>
            <Link to="/pristatymas" className="bg-[#FFF3E0] hover:bg-[#FFE0B2] rounded-2xl p-6 text-center transition-colors">
              <Download className="w-8 h-8 text-[#FF9F43] mx-auto mb-3" />
              <h3 className="font-semibold text-[#2D3748]">Pristatymo sąlygos</h3>
              <p className="text-sm text-[#718096] mt-1">Skaitmeninių produktų pristatymas</p>
            </Link>
            <Link to="/grazinimas" className="bg-[#F3E5F5] hover:bg-[#E1BEE7] rounded-2xl p-6 text-center transition-colors">
              <ArrowRight className="w-8 h-8 text-[#9B59B6] mx-auto mb-3 rotate-180" />
              <h3 className="font-semibold text-[#2D3748]">Grąžinimo politika</h3>
              <p className="text-sm text-[#718096] mt-1">Pinigų grąžinimo sąlygos</p>
            </Link>
          </div>

          {/* Seller Information */}
          <div className="bg-[#FAFAF8] rounded-3xl p-8 border border-slate-200">
            <h3 className="text-xl font-['Poppins'] font-bold text-[#2D3748] mb-6 text-center">
              Pardavėjo informacija
            </h3>
            <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
              <div className="text-center md:text-left">
                <p className="text-[#718096] mb-2"><strong className="text-[#2D3748]">Pardavėjas:</strong> Dmitrij Borodin</p>
                <p className="text-[#718096]"><strong className="text-[#2D3748]">Ind. veiklos pažymos nr.:</strong> 706574</p>
              </div>
              <div className="text-center md:text-left">
                <p className="text-[#718096] mb-2"><strong className="text-[#2D3748]">El. paštas:</strong> info@tavoemocijos.lt</p>
                <p className="text-[#718096]"><strong className="text-[#2D3748]">Telefonas:</strong> +370 678 38321</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
